import { render, staticRenderFns } from "./dwelling-queue-info.vue?vue&type=template&id=d63fb5ec&scoped=true"
import script from "./dwelling-queue-info.vue?vue&type=script&lang=js"
export * from "./dwelling-queue-info.vue?vue&type=script&lang=js"
import style0 from "./dwelling-queue-info.vue?vue&type=style&index=0&id=d63fb5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63fb5ec",
  null
  
)

export default component.exports